// extracted by mini-css-extract-plugin
export default {"box":"Box_box__utm+f","content":"Box_content__+psCE","container":"Box_container__W-gPx","panel":"Box_panel__lMdAV","children":"Box_children__4Cpj7"};